import {

    GET_DISTRICT_DEFINITIONS_SUCCESS,
    ADD_DISTRICT_DEFINITION_SUCCESS,
    UPDATE_DISTRICT_DEFINITION_SUCCESS,
    DELETE_DISTRICT_DEFINITION_SUCCESS,
    DISTRICT_API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], 
    error: {},
  }
  
  const districtDefinition = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_DISTRICT_DEFINITIONS_SUCCESS:
      case ADD_DISTRICT_DEFINITION_SUCCESS:
      case UPDATE_DISTRICT_DEFINITION_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
        }
  
      case DELETE_DISTRICT_DEFINITION_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.filter(
            record => record.guid.toString() !== action.payload.toString()
          ),
        }
  
      case DISTRICT_API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default districtDefinition